/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Day_FriInputs */

const cs_portals_day_fri = /** @type {(inputs: Portals_Day_FriInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pá`)
};

const en_portals_day_fri = /** @type {(inputs: Portals_Day_FriInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fri`)
};

/**
* | output |
* | --- |
* | "Fri" |
*
* @param {Portals_Day_FriInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_day_fri = /** @type {((inputs?: Portals_Day_FriInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Day_FriInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_day_fri(inputs)
	return cs_portals_day_fri(inputs)
});